import React, { useEffect } from 'react';
import { Button, createStyles, Grid, Icon, makeStyles, Typography} from '@material-ui/core';
import { Action, Column, Options } from 'material-table';

import { CutoutModel, cutoutModelInitial } from '../../../../Models/CutoutModel';
import { BasicConfirmDialog } from '../../../../shared/components/BasicConfirmDialog';
import { TableCommon } from '../../../../shared/components/TableCommon';
import { TableEmpty } from '../../../../shared/components/TableEmpty';
import { ClientContext } from '../../ClientContext';
import { EditAction } from '../../../../shared/enum/EditAction';
import { OrganogramModel } from '../../../../Models/OrganogramModel';
import { getTableColumn } from '../../../../shared/operators';
import { HomeContext } from '../../../Home/HomeContext';
import { CutoutModal } from './CutoutModal';

const useStyles = makeStyles(() => createStyles({
    cardHeight: {
        overflow: 'hidden',
        maxHeight: '240px'
    },
    textButton: {
        paddingLeft: 0,
        '&:hover': {
            textDecorationLine: 'underline',
        },
    }
}));

export function ClientCutout() {
    const classes = useStyles();

    const homeContext = React.useContext(HomeContext); 
    const clientContext = React.useContext(ClientContext);

    const [currentCutout, setCurrentCutout] = React.useState<CutoutModel>({...cutoutModelInitial});
    const [actionIndex, setActionIndex] = React.useState<number>(-1);

    const [isCutoutModalOpen, setIsCutoutModalOpen] = React.useState(false);

    const [isConfirmDeletionOfCutoutModalOpen, setIsConfirmDeletionOfCutoutModalOpen] = React.useState(false);
    const [isInEditMode, setIsInEditMode] = React.useState(false);

    const tablecutoutsColumns: Column<CutoutModel>[] = [getTableColumn('Descrição', 'description', 'string', 'left', undefined, 'asc', true, true)];
    
    const tablecutoutsOptions: Options<CutoutModel> = {
        filtering: true,
        sorting: true,
        showTitle: false,
        toolbar: false,
        headerStyle: {
            fontSize: '14px',
            whiteSpace: 'nowrap'
        },
        pageSizeOptions: [5, 10, 15],
        pageSize: 5,
    };
    
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tablecutoutsActions: Action<any>[] = [
        {
            icon: 'edit',
            iconProps: { style: { fontSize: '20px' } },
            tooltip: 'Editar recorte',
            onClick: (_, rowData) => { handleEditButton(rowData, rowData.tableData.id); }
        },
        {
            icon: 'delete_outline',
            iconProps: { style: { fontSize: '20px' } },
            tooltip: 'Apagar recorte',
            onClick: (_, rowData) => { openConfirmDeletionModal(rowData.id); },
        },
    ];

    const handleEditButton = (cutout: CutoutModel, index: number) => {
        const cut = JSON.parse(JSON.stringify(cutout));
        const organogramList = JSON.parse(JSON.stringify(clientContext.flatOrganogram));

        organogramList.forEach((org : OrganogramModel) => {
            const index = cut.organograms.findIndex((o : OrganogramModel) => o.id == org.id);
            if (index != -1)
                org.editAction = EditAction.SELECTED;
        });

        if (organogramList.length > 0) {
            clientContext.setCutoutOrganogram(organogramList);

            setIsInEditMode(true);
            setCurrentCutout(cut);
            setActionIndex(index);
            setIsCutoutModalOpen(true);
        }

    };

    // const handleDeleteButton = (index: number) => {
    //     const cutouts = [ ...clientContext.cutouts.filter((s) => s.editAction != EditAction.DELETE && s.endOfPeriod == null) ];
        
    //     if (cutouts[index].editAction == EditAction.INSERT)
    //         cutouts.splice(index, 1);
    //     else
    //         cutouts[index].editAction = EditAction.DELETE;

    //     clientContext.setCutouts(cutouts);

    //     setIsConfirmDeletionOfCutoutModalOpen(false);
    //     setActionIndex(-1);
    // };
    const openConfirmDeletionModal = (index: number) => {
        setActionIndex(index);
        setIsConfirmDeletionOfCutoutModalOpen(true);
    };

    const handleDeleteButton = (id: number) => {
        
        const updateCutouts = [...clientContext.cutouts];
        const cutoutIndex = updateCutouts.findIndex(cutout => cutout.id === id);
        
        if(cutoutIndex >= 0){
            if (updateCutouts[cutoutIndex].editAction !== EditAction.DELETE && updateCutouts[cutoutIndex].endOfPeriod == null) {
                if (updateCutouts[cutoutIndex].editAction === EditAction.INSERT) {
                    updateCutouts.splice(cutoutIndex, 1); 
                } 
                else {
                            updateCutouts[cutoutIndex].editAction = EditAction.DELETE;
                }
                }
        }
    
        clientContext.setCutouts(updateCutouts);
        
        setIsConfirmDeletionOfCutoutModalOpen(false);
    };   
    
    
    

    const handleNewCutout = () => {
        const organogramList = JSON.parse(JSON.stringify(clientContext.flatOrganogram));
        setIsCutoutModalOpen(true);

        if (organogramList.length > 0) {            
            clientContext.setCutoutOrganogram(organogramList);
        }
        else
            homeContext.showWarning('É necessário organograma para cadastro de recorte.');
    };
    
    const getAddNewButton = () => {
        return (
            <Grid
                item
                xs={12}>
                <Button
                    onClick={() => handleNewCutout()}
                    className={classes.textButton}
                    startIcon={<Icon color='primary'>add</Icon>}>
                    Cadastrar novo recorte
                </Button>
            </Grid>
        );
    };

    const getCutoutRender = () => {
        return (
            <>
                {!clientContext.cutouts.length || clientContext.cutouts.filter((c) => c.editAction != EditAction.DELETE && c.endOfPeriod == null).length == 0
                    ? <Grid 
                        item 
                        xs={12} 
                        className={classes.cardHeight}>
                        <TableEmpty 
                            displayText="Nenhum recorte cadastrado" 
                            cssProperties={{ 
                                minHeight: '150px',
                            }} /> 
                    </Grid>
                    : <Grid 
                        item 
                        xs={12}>
                        <TableCommon
                            tableData={clientContext.cutouts.filter((c) => c.editAction != EditAction.DELETE && c.endOfPeriod == null)}
                            tableColumns={tablecutoutsColumns}
                            tableActions={tablecutoutsActions}
                            extraOptions={tablecutoutsOptions}
                            emptyDataSourceMessage='Nenhum recorte cadastrado'
                        />
                    </Grid>
                }
            </>
        );
    };


    return (
        <>
            <Grid container direction="column" spacing={1}>  
                <Grid item xs={12}>
                    <Typography variant="subtitle1">Recorte</Typography>
                </Grid>
                { getAddNewButton() }
                { getCutoutRender() }
            </Grid>
                
            <CutoutModal
                isOpen={ isCutoutModalOpen }
                setIsOpen={ setIsCutoutModalOpen }
                isInEditMode={ isInEditMode }
                setIsInEditMode={ setIsInEditMode }
                currentCutout={ currentCutout }
                setCurrentCutout={ setCurrentCutout }
                actionIndex={ actionIndex }
                setActionIndex={ setActionIndex } />

            <BasicConfirmDialog
                title="Excluir recorte?"
                description="Ao excluir um recorte ele não será mais exibido no dashboard, deseja excluir mesmo assim."
                textFirstButton="Excluir"
                handleFirstButton={() => handleDeleteButton(actionIndex)}
                textSecondButton="Voltar"
                handleSecondButton={() => setIsConfirmDeletionOfCutoutModalOpen(false)}
                reverseButtons={true}
                cssProperties={{ justifyButtons: 'flex-end' }}          
                open={isConfirmDeletionOfCutoutModalOpen} />
        </>
    );
}